<template>
  <a-form-item
    :label="varLabel"
    :label-col="formItemLayout.labelCol"
    :wrapper-col="formItemLayout.wrapperCol"
  >
    <a-input
      :size="size"
      :disabled="disabled"
      :addonBefore="prefix"
      v-decorator="[
                    `${varName}`,
                    {rules: [{ required: varRequired, message: message, type: 'string', pattern: new RegExp(/^\+\d+$/) }],
                    initialValue: varInitial
                    }]"
      :placeholder="varLabel"
    />
    <a-icon slot="addonAfter" :type="icon" v-if="icon" />
    <a-alert :message="description" type="info" showIcon style="margin-top:5px;" v-if="description" />
  </a-form-item>
</template>

<script>
import { formLayoutMixin } from "@/mixins/formLayout";

export default {
  mixins: [formLayoutMixin],
  props: {
    varName: String,
    varLabel: String,
    varInitial: String,
    varRequired: Boolean,
    formLayout: String,
    size: String,
    icon: [String, null],
    prefix: [String, null],
    description: [String, null],
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    message() {
      return `Please enter ${this.varLabel.toLowerCase()} in format +1234567890`;
    }
  }
};
</script>
